import { Injectable, OnDestroy } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { filter, switchMap } from 'rxjs/operators';
import { DeviceService } from './devices.service';
import { Subject, Subscription, interval } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceStatusService implements OnDestroy {
  private deviceStatusCheckInterval = new Subject();
  subscriptions = new Subscription();

  constructor(private settingsService: SettingsService, private deviceService: DeviceService) {}

  initialize() {
    console.log('Starting device status service');
    this.subscribeToSettingsChanged();
    this.getSettings();
  }

  private subscribeToSettingsChanged() {
    this.subscriptions.add(
      this.settingsService.settingsUpdated
        .pipe(filter((settings) => this.settingsService.hasSettingBeenUpdated(Settings.DEVICE_STATUS_CHECK, settings)))
        .subscribe(() => {
          this.getSettings();
        })
    );
  }

  private getSettings() {
    const deviceStatusCheckInterval = this.settingsService.getSettingValue(Settings.DEVICE_STATUS_CHECK) * 1000;
    this.deviceStatusCheckInterval.next(deviceStatusCheckInterval ?? 30000);
    this.startPolling();
  }

  private startPolling() {
    this.subscriptions.add(
      this.deviceStatusCheckInterval
        .pipe(switchMap((deviceStatusCheckInterval: number) => interval(deviceStatusCheckInterval)))
        .subscribe(() => this.getDeviceStatus())
    );
  }

  private getDeviceStatus() {
    const deviceId = this.deviceService.getDeviceId();

    if (!deviceId) {
      return;
    }

    this.deviceService.updateThisDevice();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
